/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
import {ThemeModule} from './@theme/theme.module';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {
	NbChatModule,
	NbDatepickerModule,
	NbDialogModule,
	NbIconModule,
	NbMenuModule,
	NbSidebarModule,
	NbSpinnerModule,
	NbThemeModule,
	NbTimepickerModule,
	NbToastrModule,
	NbWindowModule,
} from '@nebular/theme';
import {AuthGuard, DataService, RoleProvider, UserService} from './@core/utils';
import {NB_AUTH_TOKEN_INTERCEPTOR_FILTER} from '@nebular/auth';
import {Interceptor} from './config/http.interceptor';
import {APP_BASE_HREF} from '@angular/common';
import {AgmCoreModule} from '@agm/core';
import {AngularFireModule} from '@angular/fire';
import {CountriesService} from './@core/utils/countries.service';
import {ShareTripComponent} from './pages/share-trip/share-trip.component';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {OrderService} from './@core/utils/order.service';
import {AuthService} from './@core/utils/auth.service';
import {AuthModule} from './auth/auth.module';
import {OwlDateTimeModule, OwlNativeDateTimeModule} from '@danielmoncada/angular-datetime-picker';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {ServiceWorkerModule} from '@angular/service-worker';
import {AngularFireMessagingModule} from '@angular/fire/messaging';
import {AngularFireStorageModule} from '@angular/fire/storage';
// import {QueryBuilderModule} from "angular2-query-builder";
import {FormsModule} from '@angular/forms';
import {AngularFirestore, AngularFirestoreModule} from '@angular/fire/firestore';
import {ReverseGeocodeService} from './@core/utils/reverse-geocode.service';
import {GenerateInvoiceService} from './@core/utils/generate-invoice.service';
import {ConstantsService} from './@core/utils/constants.service';
import {MbscModule} from '@mobiscroll/angular';
import {MessagingService} from './@core/utils/messaging.service';
import {environment} from '../environments/environment';
import {NbEvaIconsModule} from '@nebular/eva-icons';

export function ConstantsServiceFactory(constantsService: ConstantsService): any {
	return () => constantsService.init();
}

@NgModule({
	declarations: [
		AppComponent,
		ShareTripComponent,
	],
	imports: [
		BrowserModule,
		FormsModule,
		BrowserAnimationsModule,
		NbThemeModule.forRoot(),
		HttpClientModule,
		AppRoutingModule,
		AuthModule,
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyAZrZg5utTPbOcTkveRd2Z7hEQdOcqjgfY',
			language: 'en',
			libraries: ['geometry', 'places'],

		}),
		ThemeModule.forRoot(),
		NbSpinnerModule,
		NbSidebarModule.forRoot(),
		NbMenuModule.forRoot(),
		NbDatepickerModule.forRoot(),
		NbDialogModule.forRoot(),
		NbWindowModule.forRoot(),
		NbToastrModule.forRoot(),
		NbTimepickerModule.forRoot(),
		ServiceWorkerModule.register('ngsw-worker.js', {enabled: true}),
		// QueryBuilderModule,
		NbChatModule.forRoot({
			messageGoogleMapKey: 'AIzaSyCxpEJRNxuy1KRNZ1XeUjzQdlf0GjCZwGg',
		}),
		CoreModule.forRoot(),
		AngularFireModule.initializeApp(environment.firebaseConfig),
		AngularFireStorageModule,
		AngularFirestoreModule,
		AngularFireMessagingModule,
		LeafletModule,
		OwlDateTimeModule,
		OwlNativeDateTimeModule,
		AngularEditorModule,
		NbEvaIconsModule,
		MbscModule,
		NbIconModule,
		OwlDateTimeModule,
		OwlNativeDateTimeModule,
	],
	bootstrap: [AppComponent],
	providers: [
		DataService,
		OrderService,
		AuthService,
		AuthGuard,
		AngularFirestore,
		UserService,
		CountriesService,
		RoleProvider,
		MessagingService,
		ReverseGeocodeService,
		GenerateInvoiceService,
		{provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},
		{
			provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER, useValue: function () {
				return false;
			},
		},
		{provide: APP_BASE_HREF, useValue: '/'},
		{ provide: APP_INITIALIZER, deps: [ConstantsService], multi: true, useFactory: ConstantsServiceFactory},
	],
	schemas: [
		CUSTOM_ELEMENTS_SCHEMA,
		NO_ERRORS_SCHEMA,
	],
})
export class AppModule {
}
